import VideoEvents from "./VideoEvents";
import {
    Video,
    VideoChangeSet,
    AddVideoInfo,
    EditVideoInfo,
    UploadDocumentIF,
    VideoPDF,
    UpdateVideoSlideIF,
} from "./models/Video";
import { VideoReaction, VideoReactionChangeSet } from "./models/VideoReaction";
import { VideoComment, VideoCommentChangeSet } from "./models/VideoComment";
import { VideoExtraMaterial } from "./models/VideoExtraMaterial";
import { FilterResult, Tag, VideoFilter } from "./models/VideoFilter";

export const getAllContents = (userId: string) =>
    ({
        type: VideoEvents.getAllContentsStarted,
        userId,
    } as const);

export const getAllContentsComplete = (allContents: FilterResult) =>
    ({
        type: VideoEvents.getAllContentsComplete,
        allContents,
    } as const);

export const filterVideos = (filter: VideoFilter) =>
    ({
        type: VideoEvents.filterVideos,
        filter,
    } as const);

export const loadVideoList = () =>
    ({
        type: VideoEvents.LoadVideoListStarted,
    } as const);

export const loadVideoListComplete = (videos: Video[]) =>
    ({
        type: VideoEvents.LoadVideoListComplete,
        videos,
    } as const);

export const loadVideoStarted = (videoId: number, userId: string) =>
    ({
        type: VideoEvents.LoadVideoStarted,
        videoId,
        userId,
    } as const);

export const loadVideoComplete = (video: Video) =>
    ({
        type: VideoEvents.LoadVideoComplete,
        video,
    } as const);

export const createVideo = (formData: FormData) =>
    ({
        type: VideoEvents.CreateStarted,
        formData,
    } as const);

export const uploadExtraMaterial = (videoId: number, formData: FormData) =>
    ({
        type: VideoEvents.UploadExtraMaterials,
        videoId,
        formData,
    } as const);

export const uploadExtraMaterialComplete = (material: VideoExtraMaterial) =>
    ({
        type: VideoEvents.UploadExtraMaterialsComplete,
        material,
    } as const);

export const deleteExtraMaterial = (videoId: number, materialId: number) =>
    ({
        type: VideoEvents.DeleteExtraMaterials,
        videoId,
        materialId,
    } as const);

export const createVideoComplete = () =>
    ({
        type: VideoEvents.CreateComplete,
    } as const);

export const updateVideo = (videoId: number, changeSet: VideoChangeSet) =>
    ({
        type: VideoEvents.Update,
        videoId,
        changeSet,
    } as const);

export const deleteVideo = (videoId: number) =>
    ({
        type: VideoEvents.Delete,
        videoId,
    } as const);
// 視聴履歴登録
export const AddViewingHistory = (userId: string, videoId: number, progressMillis: number) =>
    ({
        type: VideoEvents.AddViewingHistory,
        userId,
        videoId,
        progressMillis,
    } as const);
export const incrementVideoViewCount = (userId: string, videoId: number) =>
    ({
        type: VideoEvents.IncrementViewCount,
        userId,
        videoId,
    } as const);

export const addVideoReaction = (videoReactionChangeSet: VideoReactionChangeSet) =>
    ({
        type: VideoEvents.ReactStarted,
        videoReactionChangeSet,
    } as const);

export const addVideoReactionComplete = (reaction: VideoReaction) =>
    ({
        type: VideoEvents.ReactComplete,
        reaction,
    } as const);

// コメントの追加
export const AddVideoComment = (videoCommentChangeSet: VideoCommentChangeSet) =>
    ({
        type: VideoEvents.AddVideoCommentStarted,
        videoCommentChangeSet,
    } as const);

export const AddVideoCommentComplete = (comment: VideoComment) =>
    ({
        type: VideoEvents.AddVideoCommentComplete,
        comment,
    } as const);

// コメントの編集
export const UpdateVideoComment = (videoCommentChangeSet: VideoCommentChangeSet) =>
    ({
        type: VideoEvents.UpdateVideoCommentStarted,
        videoCommentChangeSet,
    } as const);

export const UpdateVideoCommentComplete = (
    videoId: number,
    videoCommentChangeSet: VideoCommentChangeSet
) =>
    ({
        type: VideoEvents.UpdateVideoCommentComplete,
        videoId,
        videoCommentChangeSet,
    } as const);

// コメントの削除
export const DeleteVideoComment = (id: number, userId: number, videoId: number) =>
    ({
        type: VideoEvents.DeleteVideoCommentStarted,
        id,
        userId,
        videoId,
    } as const);

export const DeleteVideoCommentComplete = (
    videoId: number,
    videoCommentChangeSet: VideoCommentChangeSet
) =>
    ({
        type: VideoEvents.DeleteVideoCommentComplete,
        videoId,
        videoCommentChangeSet,
    } as const);

// コメントの返信
export const ReplayToVideoComment = (comment: VideoComment) =>
    ({
        type: VideoEvents.ReplayToVideoCommentStarted,
        comment,
    } as const);

export const replayToVideoCommentComplete = (videoCommentChangeSet: VideoCommentChangeSet) =>
    ({
        type: VideoEvents.ReplayToVideoCommentComplete,
        videoCommentChangeSet,
    } as const);

// 新規Tag作成
export const createNewTag = (newTag: string, tagInput: string[]) =>
    ({
        type: VideoEvents.createNewTagStarted,
        newTag,
        tagInput,
    } as const);

export const createNewTagCompleted = (tagOutput: Tag[]) =>
    ({
        type: VideoEvents.createNewTagCompleted,
        tagOutput,
    } as const);

export const createNewTagFailed = (tagOutput: Tag[], message: string) =>
    ({
        type: VideoEvents.createNewTagFailed,
        tagOutput,
        message,
    } as const);

export const ResetDuplicateError = () =>
    ({
        type: VideoEvents.resetDuplicateError,
    } as const);

export const getTagList = (tagInput: string[]) =>
    ({
        type: VideoEvents.getTagListStarted,
        tagInput,
    } as const);

export const getTagListComplete = (tagOutput: Tag[]) =>
    ({
        type: VideoEvents.getTagListComplete,
        tagOutput,
    } as const);

// ビデオ追加
export const AddVideo = (video: AddVideoInfo) =>
    ({
        type: VideoEvents.AddVideoStarted,
        video,
    } as const);

export const AddVideoComplete = () =>
    ({
        type: VideoEvents.AddVideoComplete,
    } as const);

export const AddVideoFailed = () =>
    ({
        type: VideoEvents.AddVideoFailed,
    } as const);

// ビデオ編集
export const EditVideo = (editVideo: EditVideoInfo) =>
    ({
        type: VideoEvents.EditVideoStarted,
        editVideo,
    } as const);

export const EditVideoComplete = (updateVideo: Video) =>
    ({
        type: VideoEvents.EditVideoComplete,
        updateVideo,
    } as const);

export const EditVideoFailed = () =>
    ({
        type: VideoEvents.EditVideoFailed,
    } as const);

// ビデオ資料アップロード
export const UploadDocument = (document: UploadDocumentIF) =>
    ({
        type: VideoEvents.UploadDocumentStarted,
        document,
    } as const);

export const UploadDocumentComplete = (document: Video) =>
    ({
        type: VideoEvents.UploadDocumentComplete,
        document,
    } as const);

export const UploadDocumentFailed = () =>
    ({
        type: VideoEvents.UploadDocumentFailed,
    } as const);

// ビデオ削除
export const DeleteVideo = (videoId: number, videoType: string) =>
    ({
        type: VideoEvents.DeleteVideoStarted,
        videoId,
        videoType,
    } as const);

export const DeleteVideoComplete = (videoId: number) =>
    ({
        type: VideoEvents.DeleteVideoComplete,
        videoId,
    } as const);

export const DeleteVideoFailed = () =>
    ({
        type: VideoEvents.DeleteVideoFailed,
    } as const);

// ビデオデータリセット
export const ResetVideos = () =>
    ({
        type: VideoEvents.ResetVideos,
    } as const);
export const ResetVideo = () =>
    ({
        type: VideoEvents.ResetVideo,
    } as const);

// ビデオスライド資料取得
export const GetVideoSlide = (videoId: string, fileId: string) =>
    ({
        type: VideoEvents.GetVideoSlide,
        videoId,
        fileId,
    } as const);
export const GetVideoSlideComplete = (videoPdf: VideoPDF) =>
    ({
        type: VideoEvents.GetVideoSlideComplete,
        videoPdf,
    } as const);

// ビデオスライド資料追加
export const UploadVideoSlide = (uploadVideoSlide: UpdateVideoSlideIF) =>
    ({
        type: VideoEvents.UploadVideoSlideStarted,
        uploadVideoSlide,
    } as const);

export const UploadVideoSlideFailed = () =>
    ({
        type: VideoEvents.UploadVideoSlideFailed,
    } as const);

export const UploadVideoSlideComplete = (videoSlide: VideoPDF) =>
    ({
        type: VideoEvents.UploadVideoSlideComplete,
        videoSlide,
    } as const);

// ビデオスライド資料編集
export const EditVideoSlide = (editVideoSlide: UpdateVideoSlideIF) =>
    ({
        type: VideoEvents.EditVideoSlideStarted,
        editVideoSlide,
    } as const);

export const EditVideoSlideFailed = () =>
    ({
        type: VideoEvents.EditVideoSlideFailed,
    } as const);

export const EditVideoSlideComplete = (videoId: number, videoSlide: VideoPDF) =>
    ({
        type: VideoEvents.EditVideoSlideComplete,
        videoId,
        videoSlide,
    } as const);

// ビデオスライド資料削除
export const DeleteVideoSlide = (videoId: number) =>
    ({
        type: VideoEvents.DeleteVideoSlideStarted,
        videoId,
    } as const);

export const DeleteVideoSlideFailed = () =>
    ({
        type: VideoEvents.DeleteVideoSlideFailed,
    } as const);

export const DeleteVideoSlideComplete = (videoId: number) =>
    ({
        type: VideoEvents.DeleteVideoSlideComplete,
        videoId,
    } as const);

// 画面収録のビデオデータを一時保存
export const SetMediaRecorderVideoFile = (videoFile: File) =>
    ({
        type: VideoEvents.SetMediaRecorderVideoFile,
        videoFile,
    } as const);

// 画面収録のビデオデータを削除
export const DeleteMediaRecorderVideoFile = () =>
    ({
        type: VideoEvents.DeleteMediaRecorderVideoFile,
    } as const);

// ローディング表示
export const VisibleLoading = () =>
    ({
        type: VideoEvents.VisibleLoading,
    } as const);

export const InvisibleLoading = () =>
    ({
        type: VideoEvents.InvisibleLoading,
    } as const);

// 統計ビデオ情報更新
export const UpdateVideoStatistics = (
    userId: number,
    videoId: number,
    videoTag: string,
    videoTitle: string,
    videoUrl: string,
    viewDurationMillis: number,
    newWatch: boolean
) =>
    ({
        type: VideoEvents.UpdateVideoStatistics,
        userId,
        videoId,
        videoTag,
        videoTitle,
        videoUrl,
        viewDurationMillis,
        newWatch,
    } as const);
